import { render, staticRenderFns } from "./WallGuestListBlockSettings.vue?vue&type=template&id=65ec7317"
import script from "./WallGuestListBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallGuestListBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports